var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "custom-icon-list" },
      _vm._l(_vm.dataList, function(item, index) {
        return _c(
          "li",
          { key: index, staticClass: "py-1", style: _vm.getIconStyle },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t(item.lang + "." + index)) +
                "\n      "
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-781a2917", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-781a2917","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/IconListStyle.vue
// module id = 1572
// module chunks = 0